import {
  EDeliveryStatus,
  EInProcessCheckStatus,
  ELoadingOrderStatus,
  EPalletType,
  EPrepareStatus,
  EProductionPlanType,
  EProductType,
  EReceiveStatus,
} from "model";
import { ECCPLocationStatus } from "model/Type/ECCPLocationStatus";
import { EMaterialRequirement } from "model/Type/EMaterialRequirement";
import { Colors } from "../utils";

export const getProgressColorByQuantity = (
  currentQuantity: number,
  planningQuantity: number
) => {
  const isNew = currentQuantity === 0;
  const isProcessing = currentQuantity < planningQuantity;
  const isComplete = currentQuantity === planningQuantity;
  const isCancel = planningQuantity === 0;

  switch (true) {
    case isNew:
      return Colors.NEW;
    case isProcessing:
      return Colors.IN_PROGRESS;
    case isComplete:
      return Colors.COMPLETE;
    case isCancel:
      return Colors.CANCEL;
    default:
      return Colors.ERROR;
  }
};

export const getProductTypeColor = (type: EProductType) => {
  switch (type) {
    case EProductType.FINISH_PRODUCT:
      return Colors.FINISH_PRODUCT;
    case EProductType.MATERIAL:
      return Colors.MATERIAL;
    case EProductType.PACKAGING:
      return Colors.PACKAGING;
    case EProductType.SALE_OFF:
      return Colors.SALE_OFF;
  }
};

export const getProductUomColor = (type: EProductType) => {
  switch (type) {
    case EProductType.FINISH_PRODUCT:
      return Colors.FINISH_PRODUCT;
    case EProductType.MATERIAL:
      return Colors.MATERIAL;
    case EProductType.PACKAGING:
      return Colors.PACKAGING;
    case EProductType.SALE_OFF:
      return Colors.SALE_OFF;
  }
};

export const getProductUoMColors = (type: EProductType) => {
  switch (type) {
    case EProductType.FINISH_PRODUCT:
      return Colors.FINISH_PRODUCT;
    case EProductType.MATERIAL:
      return Colors.MATERIAL;
    case EProductType.PACKAGING:
      return Colors.PACKAGING;
    case EProductType.SALE_OFF:
      return Colors.SALE_OFF;
  }
};

export const getReceiveStatusColor = (type: EReceiveStatus) => {
  switch (type) {
    case EReceiveStatus.NEW:
      return Colors.NEW;
    case EReceiveStatus.IN_PROGRESS:
      return Colors.IN_PROGRESS;
    case EReceiveStatus.COMPLETE:
      return Colors.COMPLETE;
  }
};
export const getLoadingOrderStatusColor = (type: ELoadingOrderStatus) => {
  switch (type) {
    case ELoadingOrderStatus.NEW:
      return Colors.NEW;
    case ELoadingOrderStatus.IN_PROGRESS:
      return Colors.IN_PROGRESS;
    case ELoadingOrderStatus.COMPLETE:
      return Colors.COMPLETE;
    case ELoadingOrderStatus.DELETE:
      return "#e74c3c";
  }
};

export const getPrepareStatusColor = (type: EPrepareStatus) => {
  switch (type) {
    case EPrepareStatus.NEW:
      return Colors.NEW;
    case EPrepareStatus.IN_PROGRESS:
      return Colors.IN_PROGRESS;
    case EPrepareStatus.COMPLETE:
      return Colors.COMPLETE;
  }
};

export const getDeliveryStatusColor = (type: EDeliveryStatus) => {
  switch (type) {
    case EDeliveryStatus.NEW:
      return Colors.NEW;
    case EDeliveryStatus.IN_PROGRESS:
      return Colors.IN_PROGRESS;
    case EDeliveryStatus.COMPLETE:
      return Colors.COMPLETE;
  }
};
export const getMaterialRequirementStatusColor = (
  type: EMaterialRequirement
) => {
  switch (type) {
    case EMaterialRequirement.NEW:
      return Colors.NEW;
    case EMaterialRequirement.BOOKING:
      return Colors.IN_PROGRESS;
    case EMaterialRequirement.BOOKED:
      return Colors.COMPLETE;
    case EMaterialRequirement.PREPARED:
      return Colors.COMPLETE;
    case EMaterialRequirement.DELIVERED:
      return Colors.COMPLETE;
  }
};

export const getProductionPlanColor = (type: EProductionPlanType) => {
  switch (type) {
    case EProductionPlanType.NEW:
      return Colors.NEW;
    case EProductionPlanType.HOLD:
      return "#969696";
    case EProductionPlanType.IN_PROGRESS:
      return Colors.IN_PROGRESS;
    case EProductionPlanType.PACKAGED:
      return "#481E81";
    case EProductionPlanType.DESTROYING:
      return "#e74c3c";
    case EProductionPlanType.COMPLETED:
      return Colors.COMPLETE;
  }
};

export const getPalletTypeColor = (type: EPalletType) => {
  switch (type) {
    case EPalletType.WOOD:
      return "#705454";
    case EPalletType.FLAT_PLASTIC:
      return "#0252b5";
    case EPalletType.HOLE_PLASTIC:
      return "#018550";
    case EPalletType.ALUMINUM:
      return "#999999";
    case EPalletType.TEMPORARY:
      return "#f74d4d";
    case EPalletType.CONTAINER_PLASTIC:
      return "#004141";
  }
};

export const getCCPLocationStatusColor = (type: ECCPLocationStatus) => {
  switch (type) {
    case ECCPLocationStatus.NEW:
      return "#0252b5";
    case ECCPLocationStatus.CHECKED:
      return Colors.COMPLETE;
  }
};

export const getInProcessStatusColor = (type: EInProcessCheckStatus) => {
  switch (type) {
    case EInProcessCheckStatus.New:
      return "#0252b5";
    case EInProcessCheckStatus.InProcess:
      return Colors.IN_PROGRESS;
    case EInProcessCheckStatus.Reviewed:
      return Colors.COMPLETE;
  }
};
